const atualizarUsuarios = (state, usuarios) => {
    state.usuarios = usuarios;
}

const atualizarUsuario = (state, usuario) => {
    state.usuario = usuario;
}

export default {
    atualizarUsuarios,
    atualizarUsuario
}